<template>
  <div class="ad-layout">
    <!-- Sol: Sidebar -->
    <div class="uk-width-1-3@m uk-flex-first uk-first-column">
      <div class="ad-sidebar-card">
        <div class="ad-sidebar-image">
          <div class="skeleton-shimmer skeleton-thumb"></div>
        </div>
        <div class="ad-sidebar-body">
          <!-- Progress -->
          <div class="ad-progress-section">
            <div class="ad-progress-header">
              <span class="skeleton-shimmer" style="width: 80px; height: 13px;"></span>
              <span class="skeleton-shimmer" style="width: 36px; height: 14px;"></span>
            </div>
            <div class="ad-progress-bar">
              <div class="skeleton-shimmer" style="width: 100%; height: 100%; border-radius: 4px;"></div>
            </div>
          </div>
          <!-- Buttons -->
          <div class="ad-actions">
            <div class="skeleton-shimmer skeleton-btn skeleton-btn--primary"></div>
            <div class="skeleton-shimmer skeleton-btn skeleton-btn--outline"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sağ: Main Content -->
    <div class="uk-width-2-3@m">
      <!-- Hero / Description -->
      <div class="ad-header">
        <div class="ad-hero">
          <div class="ad-hero-content">
            <!-- Badge -->
            <span class="skeleton-shimmer" style="display: inline-block; width: 100px; height: 24px; border-radius: 20px;"></span>
            <!-- Title -->
            <div class="skeleton-shimmer" style="width: 60%; max-width: 360px; height: 28px; margin: 12px 0 20px; border-radius: 6px;"></div>
            <!-- Meta Row -->
            <div class="ad-meta-row">
              <div class="ad-meta-item">
                <span class="skeleton-shimmer" style="width: 16px; height: 16px; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 90px; height: 14px;"></span>
              </div>
              <div class="ad-meta-item">
                <span class="skeleton-shimmer" style="width: 16px; height: 16px; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 120px; height: 14px;"></span>
              </div>
              <div class="ad-meta-item">
                <span class="skeleton-shimmer" style="width: 16px; height: 16px; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 110px; height: 14px;"></span>
              </div>
            </div>
            <!-- Date Row -->
            <div class="ad-date-row">
              <div class="ad-date-item">
                <span class="skeleton-shimmer" style="width: 14px; height: 14px; border-radius: 3px;"></span>
                <span class="skeleton-shimmer" style="width: 160px; height: 13px;"></span>
              </div>
              <div class="ad-date-item">
                <span class="skeleton-shimmer" style="width: 14px; height: 14px; border-radius: 3px;"></span>
                <span class="skeleton-shimmer" style="width: 150px; height: 13px;"></span>
              </div>
            </div>
            <!-- Rating -->
            <div class="ad-rating">
              <div class="d-flex align-items-center" style="gap: 8px;">
                <span class="skeleton-shimmer" style="width: 30px; height: 18px; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 100px; height: 18px; border-radius: 4px;"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tab Wrapper -->
      <div class="ad-tab-wrapper">
        <!-- Tab Nav -->
        <div class="ad-tab-nav">
          <ul style="list-style: none; margin: 0; padding: 0; display: flex; gap: 6px;">
            <li class="uk-active">
              <a href="javascript:void(0)" style="pointer-events: none;">
                <span class="skeleton-shimmer" style="width: 18px; height: 18px; display: inline-block; vertical-align: middle; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 80px; height: 14px; display: inline-block; vertical-align: middle;"></span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" style="pointer-events: none;">
                <span class="skeleton-shimmer" style="width: 18px; height: 18px; display: inline-block; vertical-align: middle; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 70px; height: 14px; display: inline-block; vertical-align: middle;"></span>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" style="pointer-events: none;">
                <span class="skeleton-shimmer" style="width: 18px; height: 18px; display: inline-block; vertical-align: middle; border-radius: 4px;"></span>
                <span class="skeleton-shimmer" style="width: 60px; height: 14px; display: inline-block; vertical-align: middle;"></span>
              </a>
            </li>
          </ul>
        </div>

        <!-- Tab Content -->
        <div class="ad-tab-content" style="padding: 24px;">
          <!-- Section Header -->
          <div class="ad-section-header">
            <div class="skeleton-shimmer" style="width: 180px; height: 20px; border-radius: 5px;"></div>
          </div>
          <!-- Description -->
          <div class="skeleton-shimmer" style="width: 55%; max-width: 260px; height: 14px; margin-bottom: 16px;"></div>
          <!-- Content List -->
          <div class="skeleton-content-list">
            <div v-for="i in 4" :key="'skeleton_item_' + i" class="skeleton-content-card">
              <div class="skeleton-content-item">
                <div class="skeleton-shimmer" style="width: 72px; height: 22px; border-radius: 4px;"></div>
                <div class="skeleton-shimmer" style="flex: 1; max-width: 240px; height: 14px;"></div>
                <div style="margin-left: auto; display: flex; align-items: center; gap: 6px;">
                  <div class="skeleton-shimmer" style="width: 14px; height: 14px; border-radius: 50%;"></div>
                  <div class="skeleton-shimmer" style="width: 50px; height: 13px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignmentDetailsSkeleton"
}
</script>

<style scoped>
@keyframes skeleton-shimmer-anim {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-shimmer {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eee 25%, #e5e5e5 50%, #eee 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

.skeleton-thumb {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.skeleton-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
}

.skeleton-btn--primary {
  background: linear-gradient(90deg, #d1dff5 25%, #dce6f8 50%, #d1dff5 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

.skeleton-btn--outline {
  background: linear-gradient(90deg, #e8ecf0 25%, #eff1f4 50%, #e8ecf0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

/* Content list */
.skeleton-content-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-content-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.skeleton-content-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .skeleton-content-item {
    padding: 10px 12px;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .skeleton-content-item {
    padding: 8px 10px;
  }
}
</style>
